import React, { useCallback } from "react";
import { TaxIdentity as TaxIdentityApi } from '../../../api/services/next';
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { TrashButton, EditButton, RegisterButton } from '../../../components/shared/icons';
import useBoolean from '../../../hooks/useBoolean.js';
import EditTaxIdentityPopup from '../popups/EditTaxIdentityPopup';
import { useTextResources } from "../../../language";
import { useConfirmPopup } from "../../../hooks/useConfirmPopup";
import { useLoader } from '../../../components/shared/utils';
import { onError } from '../../../components/shared/messages';

const ActionsColumn = ({ row, column: { saveTaxIdentity } }) => {
    const text = useTextResources();
    const loader = useLoader();

    const { confirm } = useConfirmPopup();
    const {
        value: isEditPopupOpen,
        setTrue: openEditPopup,
        setFalse: closeEditPopup
    } = useBoolean(false);

    const handleRemove = useCallback(() => {
        saveTaxIdentity({
            ...row,
            IsActive: false,
        });
    }, [row, saveTaxIdentity]);

    const handleRegister = useCallback(async () => {
        loader(true);
        try {
            const response = await TaxIdentityApi.GetTaxAuthorityRegisterUrl({ Id: row.Id });
            window.open(response.RegisterUrl, '_blank');
        } catch (error) {
            onError(error);
        } finally {
            loader(false);
        }
    }, [row.Id, loader]);

    const confirmRemove = useCallback(async () => {
        await confirm({
            header: `${text('Delete')} ${text('TaxIdentity')}`,
            confirmButton: {
                content: text('Yes'),
                positive: true,
            },
            cancelButton: {
                content: text('No'),
                negative: true,
            },
            onConfirm: handleRemove,
        });
    }, [confirm, text, handleRemove]);

    if (!row.IsActive) {
        return null;
    }

    return (
        <div>
            <Button.Group icon>
                <RegisterButton onClick={handleRegister} style={{ marginRight: '10px' }} />
                <EditButton onClick={openEditPopup} style={{ marginRight: '10px' }} />
                <TrashButton onClick={confirmRemove} />
            </Button.Group>
            <EditTaxIdentityPopup
                open={isEditPopupOpen}
                taxIdentity={row}
                save={saveTaxIdentity}
                onClose={closeEditPopup}
            />
        </div>
    );
};

ActionsColumn.propTypes = {
    row: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        IsActive: PropTypes.bool.isRequired,
    }).isRequired,
    column: PropTypes.shape({
        saveTaxIdentity: PropTypes.func.isRequired,
    }).isRequired,
};

export default ActionsColumn;